import { render, staticRenderFns } from "./singleEditModal.vue?vue&type=template&id=0b028e6c&scoped=true"
import script from "./singleEditModal.vue?vue&type=script&lang=js"
export * from "./singleEditModal.vue?vue&type=script&lang=js"
import style0 from "./singleEditModal.vue?vue&type=style&index=0&id=0b028e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b028e6c",
  null
  
)

export default component.exports